// extracted by mini-css-extract-plugin
export var highlightFade = "_3j-4";
export var highlighted = "_3j-3";
export var table = "_3j-1";
export var tableContainer = "_3j-0";
export var totalsRow = "_3j-2";